import { service } from '../../../service';

const state = {
  loading: false,
  items: [],
  clientInvoices: [],
  chart_data: [],
  invoiceDetails: [],
};

const actions = {
  async resetWindowHistoryDataState({ commit, rootState }, urlParams) {
    commit('setLoading', true);
    commit('setInvoiceChartData', []);
    commit('clientInvoices', []);
  },

  async fetchInvoiceChartData({ commit, rootState }, urlParams) {
    commit('setLoading', true);
    var url = `/invoices/chart/client/${urlParams.client_id}/${urlParams.frequency}?start_date=${urlParams.start_date}&end_date=${urlParams.end_date}`;
    return service.get(url).then((result) => {
      commit('setInvoiceChartData', result);
      return;
    });
  },

  async fetchByClient({ commit, rootState }, data) {
    commit('setLoading', true);

    var url = `/invoices/client/${data.client_id}`;
    url = url.params(data);
    return service.get(url).then((result) => {
      commit('setClientInvoices', result);
    });
  },

  async fetchRecentByClient({ commit, rootState }, id) {
    return service.get(`/invoices/${id}/recent`).then((result) => {
      return result;
    });
  },

  async fetchById({ commit, rootState }, data) {
    commit('setLoading', true);
    return service.get(`/invoices/${data.invoice_id}?`).then((result) => {
      commit('setInvoiceDetails', result);
    });
  },

  async fetch({ commit, rootState }, search) {
    commit('setLoading', true);

    console.log(search);
    var type = search.type.replace('#', '').trim();
    var term = search.term.trim();
    console.log(type);

    return service
      .get(
        `/invoices/${rootState.account.company._id}/${rootState.account.location._id}?type=${type}&term=${term}&page=${search.page}`
      )

      .then((result) => {
        // console.log(result);
        commit('setItems', result.invoices);
      });
  },

  async fetchAll({ commit, rootState }, payload) {
    commit('setLoading', true);

    return service
      .get(
        `/invoices/${rootState.account.company._id}/${rootState.account.location._id}`
      )
      .then((result) => {
        return result.invoices;
      });
  },

  // fetchById({ commit, rootState }, id) {
  //   commit('setLoading', true);

  //   return service
  //     .get(
  //       `/invoices/${rootState.account.company._id}/${rootState.account.location._id}/${id}`
  //     )
  //     .then(result => {
  //       commit('setLoading', false);
  //       return result;
  //     });
  // },

  async create({ dispatch, commit, rootState }, payload) {
    return service
      .post(
        `/invoices/${rootState.account.company._id}/${rootState.account.location._id}`,
        payload
      )
      .then((result) => {
        console.log(result);
        commit('newItem', result.invoice);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async createBulk({ dispatch, commit, rootState }, payload) {
    var result = await service.post(
      `/invoices/${rootState.account.company._id}/${rootState.account.location._id}/bulk`,
      payload
    );
    if (result) {
      commit('newItems', result.invoices);
      dispatch('alert/success', result.message, { root: true });
      return;
    }
  },

  async update({ dispatch, commit, rootState }, payload) {
    return service
      .patch(
        `/invoices/${rootState.account.company._id}/${payload._id}`,
        payload
      )
      .then((result) => {
        commit('updateItem', result.invoice);
        dispatch('alert/success', result.message, { root: true });
        return result.client;
      });
  },

  async delete({ dispatch, commit, rootState }, payload) {
    return service
      .delete(`/invoices/${rootState.account.company._id}/${payload._id}`)
      .then((result) => {
        commit('deleteItem', result.id);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setInvoiceChartData(state, items) {
    state.chart_data = items.invoice_total_daily;
    state.loading = false;
  },
  setInvoiceDetails(state, items) {
    state.invoiceDetails = items.invoice;
    state.loading = false;
  },
  setClientInvoices(state, items) {
    state.clientInvoices = items;
    state.loading = false;
  },
  setItems(state, items) {
    state.items = items;
    state.loading = false;
  },
  newItem(state, item) {
    state.items.unshift(item);
    state.loading = false;
  },
  newItems(state, items) {
    state.items = state.items.concat(items);
    state.loading = false;
  },
  updateItem(state, item) {
    var index = state.items.findIndex((i) => {
      return i._id === item._id;
    });
    if (index !== -1) {
      state.items.splice(index, 1, item);
    }
    state.loading = false;
  },
  deleteItem(state, id) {
    var index = state.items.findIndex((i) => {
      return i._id === id;
    });
    if (index !== -1) {
      state.items.splice(index, 1);
    }
    state.loading = false;
  },
};

export const invoices = {
  namespaced: true,
  state,
  actions,
  mutations,
};
